import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpLazyLoad from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import { Language } from './i18.constant';

i18n
  .use(LanguageDetector)
  .use(HttpLazyLoad)
  .use(initReactI18next)
  .init({
    fallbackLng: Language.az,
    supportedLngs: [Language.az, Language.ru, Language.en],
    interpolation: { escapeValue: false },
    lng: (function () {
      const lngFromPath = window?.location?.pathname?.split('/')[1];

      return ['ru', 'az', 'en'].includes(lngFromPath) ? lngFromPath : 'az';
    })(),
    react: {
      useSuspense: true,
    },
    detection: {
      order: ['customPath', 'sessionStorage', 'querystring', 'navigator', 'path'],
      caches: ['localStorage'],
      lookupFromPathIndex: 0,
    },
  });

export default i18n;
